import React from 'react';
import PageHeader from './components/PageHeader';
import CampaignCalendar from './CampaignCalendar';
import { useNavigate } from 'react-router-dom';

function MarketingHub() {
  const navigate = useNavigate();

  const tiles = [
    {
      path: '/marketing-hub/contacts',
      label: 'Contact Manager',
      icon: '👥',
      description: 'Manage contacts, import CSV, sync customers, organise lists'
    },
    {
      path: '/marketing-hub/campaigns',
      label: 'Campaigns',
      icon: '📧',
      description: 'Create and send email campaigns and newsletters'
    },
    {
      path: '/marketing-hub/templates',
      label: 'Master Templates',
      icon: '📄',
      description: 'View the locked newsletter masters used by automation'
    },
    {
      path: '/marketing-hub/images',
      label: 'Image Library',
      icon: '🖼️',
      description: 'Manage Doorbase-hosted logos and marketing images'
    },
    {
      path: '/marketing-hub/topics',
      label: 'Topics',
      icon: '💡',
      description: 'Research pipeline — approve, reject, or add content ideas'
    },
    {
      path: '/marketing-hub/blog-posts',
      label: 'Blog Posts',
      icon: 'Blog',
      description: 'Approve generated website blogs and send them to WordPress'
    },
    {
      path: '/marketing-hub/analytics',
      label: 'Analytics',
      icon: '📊',
      description: 'Track opens, clicks, and engagement'
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Marketing Hub"
        subtitle="Manage your marketing contacts, campaigns and newsletters"
        backTo="/dashboard"
        backLabel="Dashboard"
        sticky
      />

      <main className="max-w-6xl mx-auto px-6 py-8 space-y-8">
        <div className="bg-gray-300 rounded-lg shadow p-6 mx-auto" style={{ width: 'fit-content', maxWidth: '1200px' }}>
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Quick Access</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4 justify-items-center">
            {tiles.map((item) => (
              <button
                key={item.path}
                onClick={() => !item.disabled && navigate(item.path)}
                disabled={item.disabled}
                className={`flex flex-col items-center p-6 bg-white rounded-lg w-full max-w-xs border-2 border-black hover:border-blue-500 hover:shadow-lg transition-all group ${item.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                <span className="text-5xl mb-3 group-hover:scale-110 transition-transform">{item.icon}</span>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{item.label}</h3>
                <p className="text-xs text-gray-500 text-center">{item.description}</p>
                {item.disabled && <span className="text-xs text-gray-400 mt-1">Coming soon</span>}
              </button>
            ))}
          </div>
        </div>

        {/* Campaign Calendar */}
        <CampaignCalendar />
      </main>
    </div>
  );
}

export default MarketingHub;
